import React from 'react';

export const OverlayLegend: React.FC<{ showOverlays: boolean; onToggle: () => void }> = ({ showOverlays, onToggle }) => (
  <div className="flex flex-wrap items-center justify-between gap-2 sm:gap-4 text-xs text-gray-600 dark:text-gray-400 mt-2">
    <div className="flex items-center gap-2 sm:gap-4">
      <div className="flex items-center gap-1">
        <div className="w-4 h-3 bg-gray-200 dark:bg-gray-700 opacity-30 rounded"></div>
        <span>Weekend</span>
      </div>
      <div className="flex items-center gap-1">
        <div className="w-4 h-3 bg-amber-100 dark:bg-amber-900 opacity-30 rounded"></div>
        <span>Holiday</span>
      </div>
    </div>
    <button onClick={onToggle} className="text-xs hover:text-gray-900 dark:hover:text-gray-200 transition-colors">
      {showOverlays ? 'Hide' : 'Show'} overlays
    </button>
  </div>
);
